import { CheckCircle2, PencilLine, XCircle } from "lucide-react";

import { Button } from "@/components/ui/button";

interface AgentApprovalBarProps {
  busy?: boolean;
  onApprove: () => void;
  onCancel: () => void;
}

export function AgentApprovalBar({ busy = false, onApprove, onCancel }: AgentApprovalBarProps) {
  return (
    <div className="flex flex-wrap items-center gap-2 rounded-2xl border border-accent/20 bg-accent-subtle/35 p-3">
      <Button disabled={busy} type="button" onClick={onApprove}>
        <CheckCircle2 className="h-4 w-4" />
        Approve &amp; Execute
      </Button>
      <Button disabled size="sm" type="button" variant="secondary">
        <PencilLine className="h-4 w-4" />
        Modify later
      </Button>
      <Button disabled={busy} size="sm" type="button" variant="ghost" onClick={onCancel}>
        <XCircle className="h-4 w-4" />
        Cancel
      </Button>
    </div>
  );
}
